var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", { class: _vm.$style.heading }, [
      _vm._v(
        "\n    We noticed you don't have a " +
          _vm._s(_vm.provider) +
          " account connected.\n  "
      ),
    ]),
    _vm._v(" "),
    _c("p", { class: _vm.$style.subHeading }, [
      _vm._v(
        "\n    The information provided does not appear to be associated with a current organization.\n  "
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }